import { FilterBy } from '../../../components/shared/DisplayFilter';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ReviewActivitySheetFilterStateType = {
  status: FilterBy[];
  pageNo: number;
  searchText: string;
};
const initialReviewActivitySheetFilterState: ReviewActivitySheetFilterStateType =
  {
    status: [
      {
        key: 'billingStatusText',
        value: [
          { id: 'pending', label: 'Pending' },
          { id: 'approved', label: 'Approved' },
        ],
      },
    ],
    pageNo: 0,
    searchText: '',
  };

export const reviewActivitySheetFilterSlice = createSlice({
  name: 'reviewActivitySheetFilter',
  initialState: initialReviewActivitySheetFilterState,
  reducers: {
    setReviewActivitySheetFilter: (
      state,
      action: PayloadAction<ReviewActivitySheetFilterStateType>,
    ) => {
      return action.payload;
    },
    resetReviewActivitySheetFilter: () => {
      return initialReviewActivitySheetFilterState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialReviewActivitySheetFilterState,
    );
  },
});

export const { setReviewActivitySheetFilter, resetReviewActivitySheetFilter } =
  reviewActivitySheetFilterSlice.actions;

export default reviewActivitySheetFilterSlice.reducer;
